import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CONTENT: {
    GET_BY_ID: (contentId) => ({ contentId }),
    API: {
      GET_BY_ID: apiResourceActionCreator('content')
    }
  }
})

export const apiAction = (authToken, contentId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${contentId}`, authToken, action.content.api.getById)

export function* getContentById(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.contentId));
}

const configuration = {
  name: 'getById',
  action: action,
  sagas: getContentById,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      selectedContent: action.payload.content
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/content/configurations/getById.js